export const Icon = () => {
    return (
        <svg width="45" height="17" viewBox="0 0 45 17" fill="#D4BC87">
            <path d="M4.01597 1.27727L2.29324 0.261298L0.261298 3.70676L1.98403 4.72273L4.01597 1.27727ZM22.5 14.5L21.484 16.2227L22.4634 16.8003L23.4606 16.2542L22.5 14.5ZM1.98403 4.72273L21.484 16.2227L23.516 12.7773L4.01597 1.27727L1.98403 4.72273ZM23.4606 16.2542L44.4606 4.75419L42.5394 1.24581L21.5394 12.7458L23.4606 16.2542Z" />
        </svg>
    );
};
